import { render, staticRenderFns } from "./NominationApplyList.vue?vue&type=template&id=144f827a"
import script from "./NominationApplyList.vue?vue&type=script&lang=js"
export * from "./NominationApplyList.vue?vue&type=script&lang=js"
import style0 from "./NominationApplyList.vue?vue&type=style&index=0&id=144f827a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports